import { addDays } from 'date-fns/addDays';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BulkRateValidation } from 'uplisting-frontend/validations';

export default class BulkRateRepositoryService extends BaseRepositoryService<
  ModelRegistry['bulk-rate']
> {
  recordName = 'bulk-rate';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = BulkRateValidation;

  get defaultParams() {
    return {
      from: new Date(),
      to: addDays(new Date(), 1),
    };
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/bulk-rate': BulkRateRepositoryService;
  }
}
